import { AsyncThunk, unwrapResult } from "@reduxjs/toolkit";
import { useCallback, useEffect, useState } from "react";
import { RootState, useAppDispatch } from "../utils/store";
import { thunkResponse } from "utils/types";
import * as Sentry from "@sentry/react";
import { useSelector } from "react-redux";

export const useRequest = <ThunkInput = void, ThunkOutput = void>(
  thunk: AsyncThunk<ThunkOutput, ThunkInput, any>,
  requestOnMount: false | (ThunkInput extends void ? true : ThunkInput) = false
) => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const myPanel = useSelector((state: RootState) => state.auth.myPanel);

  const sendRequest = useCallback(
    async (
      args:
        | ThunkInput
        | (ThunkInput & thunkResponse<ThunkOutput>)
        | thunkResponse<ThunkOutput> // I Hate Typescript <-- THIS WAS AI GENERATED (Copilot) O_o
    ) => {
      const { onSuccess, onError } = (args as thunkResponse<ThunkOutput>) ?? {};
      setLoading(true);
      try {
        const res = await dispatch(thunk(args as any));
        setLoading(false);
        onSuccess?.(unwrapResult(res));
      } catch (error: any) {
        setLoading(false);
        Sentry.withScope((scope) => {
          scope.setTag("error-type", "api-failure");
          scope.setExtra("API Endpoint", "/api/data");
          scope.setExtra("Error Message: ", error.message);
          scope.setExtra("Error: ", JSON.stringify(error));
          scope.setUser({ name: myPanel?.name, phone: myPanel?.phone });
          Sentry.captureMessage(`API Error: ${error.message}`);
        });
        onError?.(error);
      }
    },
    []
  );

  // I Hate Typescript
  useEffect(() => {
    if (requestOnMount) {
      if (typeof requestOnMount === "boolean") {
        (sendRequest as any)();
      } else {
        (sendRequest as any)(requestOnMount);
      }
    }
  }, []);

  return { loading, sendRequest };
};
